import React from 'react'
import { renderRichText } from './marketing/RichTextRenderer'
import NextImage from 'next/image'
import { AlternatingLayout as AlternatingLayoutTypes } from 'types/generated/contentful'
import { Video } from './Video'

interface AlternatingLayoutProps
  extends React.HtmlHTMLAttributes<HTMLDivElement> {
  entry: AlternatingLayoutTypes
}

export default function AlternatingLayout({
  entry,
  className,
  ...props
}: AlternatingLayoutProps): JSX.Element | null {
  const { label, title, blocksCollection } = entry
  const { items } = blocksCollection || {}

  return items && label && title ? (
    <div
      className={`my-20 sm:my-30 w-screen ml-[calc((100vw-100%)/2*-1)] ${
        className || ''
      }`}
      {...props}
    >
      <div className='horizontal-padding max-w-screen-2xl mx-auto'>
        <div className='sm:text-center'>
          <p className='label text-neutral-60 !mt-0'>{label}</p>
          <h2 className='!mt-4'>{title}</h2>
        </div>

        <div>
          {items.map((block, index) => {
            switch (block?.__typename) {
              case 'AlternatingLayoutItem':
                const { title, text, image } = block || {}

                return (
                  text &&
                  image && (
                    <div
                      className='spacer-xl sm:grid-cols-2 sm:grid items-center'
                      key={block?.sys.id}
                    >
                      <div
                        className={
                          index % 2
                            ? 'order-1 sm:mr-20 lg:mr-30'
                            : 'order-2 sm:ml-20 lg:ml-30'
                        }
                      >
                        <h3 className='!mt-0'>{title}</h3>
                        <div className='spacer-3xs'>{renderRichText(text)}</div>
                      </div>

                      {image.url &&
                        image.width &&
                        image.height &&
                        image.title && (
                          <div
                            className={`shadow-lg rounded-8 overflow-hidden mt-8 sm:mt-0 ${
                              index % 2 ? 'order-2' : 'order-1'
                            }`}
                          >
                            <NextImage
                              src={image.url}
                              layout='responsive'
                              width={image.width}
                              height={image.height}
                              alt={image.title}
                            />
                          </div>
                        )}
                    </div>
                  )
                )
              case 'ComponentVideo':
                return <Video key={block.url!} url={block.url!} />
            }
          })}
        </div>

        {/* <div className='text-with-images horizontal-padding max-w-screen-2xl mx-auto grid gap-10 lg:grid-cols-2 lg:gap-16'>
        <div>{renderRichText(text)}</div>

        <div className='grid gap-6 md:gap-8'>
          {items.map(
            (image, index) =>
              image?.url &&
              image.width &&
              image.height &&
              image.title && (
                <div key={`${image.title}-${index}`}>
                  <NextImage
                    src={image.url}
                    layout='responsive'
                    width={image.width}
                    height={image.height}
                    alt={image.title}
                  />
                  <small className='block mt-3 text-neutral-60'>
                    {image.title}
                  </small>
                </div>
              ),
          )}
        </div>
      </div> */}
      </div>
    </div>
  ) : null
}
